// extracted by mini-css-extract-plugin
export default {"postsBlock":"Myposts_postsBlock__QrKzm","posts":"Myposts_posts__0oEpK","font":"Myposts_font__his7U","like":"Myposts_like__17065","form":"Myposts_form__TfrKt"};